import { Roles } from "@/helpers/roles";

export const marketCategoryRoutes = [
    {
        path: '',
        name: 'adminMarketCategories',
        component: () => import('@/pages/back/registry/market-categories/MarketCategoryList.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.MARKET_CATEGORY_READ],
        },
    },
    {
        path: 'create',
        name: 'adminMarketCategoryCreate',
        component: () => import('@/pages/back/registry/market-categories/MarketCategoryCreate.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.MARKET_CATEGORY_CREATE],
        },
    },
    {
        path: 'edit/:code',
        name: 'adminMarketCategoryEdit',
        component: () => import('@/pages/back/registry/market-categories/MarketCategoryEdit.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.MARKET_CATEGORY_EDIT],
        },
    },
    {
        path: 'view/:code',
        name: 'adminMarketCategoryView',
        component: () => import('@/pages/back/registry/market-categories/MarketCategoryView.vue'),
        meta: {
            requiresAuth: true,
            roles: [Roles.ADMIN, Roles.MARKET_CATEGORY_READ],
        },
    },
];
